import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import SuperAdminNav from "../components/adNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, useParams, Link } from "react-router-dom";

const AddMember_Admin = () => {
  const { memId } = useParams();
  const [selected1, setSelected1] = useState([]);
  const [selected2, setSelected2] = useState([]);
  const [selected3, setSelected3] = useState([]);
  const [selected4, setSelected4] = useState([]);
  const [selected5, setSelected5] = useState([]);
  const [selected6, setSelected6] = useState([]);
  const userId = localStorage.getItem("username");
  const [formData, setFormData] = useState({ newPurNo: "", shift: "" });
  const [branches, setBranches] = useState([]);
  const [dept, setDept] = useState([]);
  const [options1, setOptions1] = useState([]); // Inv - Master
  const [options2, setOptions2] = useState([]); // Inv - Trans
  const [options3, setOptions3] = useState([]); // Inv - Report
  const [options4, setOptions4] = useState([]); // Veh - Master
  const [options5, setOptions5] = useState([]); // Veh - Trans
  const [options6, setOptions6] = useState([]); // Veh - Report
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [dropdown1Visible, setDropdown1Visible] = useState(false);
  const [dropdown2Visible, setDropdown2Visible] = useState(false);
  const [dropdown3Visible, setDropdown3Visible] = useState(false);
  const [dropdown4Visible, setDropdown4Visible] = useState(false);
  const [dropdown5Visible, setDropdown5Visible] = useState(false);
  const [dropdown6Visible, setDropdown6Visible] = useState(false);

  // ===== NEW: derive module visibility from localStorage.nissi_admin =====
  const admin = useMemo(() => {
    try {
      const raw = localStorage.getItem("nissi_admin");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  // Module visibility derived from num_licenses
 const numLic = useMemo(() => Number(admin?.num_licenses || 0), [admin]);
 const showVehicle   = numLic === 1 || numLic === 3; // 1 or 3 → vehicle visible
 const showInventory = numLic === 2 || numLic === 3; // 2 or 3 → inventory visible
 const bothHidden    = !showVehicle && !showInventory;
 
 // NEW: collapse visibility into a single number for the API
 const moduleCode = useMemo(() => {
   if (showVehicle && showInventory) return 3; // both
   if (showVehicle) return 1;                  // vehicle
   if (showInventory) return 2;                // inventory
   return 0;                                   // none (fallback)
 }, [showVehicle, showInventory]);
 
  const gridStyleFor = (colsVisible) => ({
    display: "grid",
    gridTemplateColumns: colsVisible === 2 ? "1fr 1fr" : "1fr",
    gap: 20,
    marginTop: 20,
  });

  useEffect(() => {
    if (!memId) return;

    const fetchMemberDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/admin_detailEdit?memId=${memId}`);
        if (response.data?.adminDetail?.length > 0) {
          const adminData = response.data.adminDetail[0];
          setFormData({
            memberId: adminData.fld_memberId || "",
            branch: adminData.fld_branch_code || "",
            name: adminData.fld_name || "",
            userName: adminData.fld_username || "",
            password: adminData.fld_pass || "",
            confirmPassword: "", // keep blank unless you want to pre-fill
            cat: adminData.fld_category || "",
            desc: adminData.fld_designation || "",
          });
        }
      } catch (error) {
        console.error("Error fetching adminDetails:", error);
      }
    };

    fetchMemberDetails();
  }, [memId]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/admin_branches`);
        setBranches(response.data.branchList || []);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchBranches();
  }, []);

  useEffect(() => {
    const fetchDept = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/admin_categories`);
        setDept(response.data.catList || []);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchDept();
  }, []);

  // Inventory - Master (preselect)
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminEdit_inventoryMaster?memId=${memId}`);
        const fetchedDepartments = response.data.permissions?.map(item => item.fld_department) || [];
        setData(response.data.permissions || []);

        if (options1.length > 0) {
          const preSelectedIndexes = options1
            .map((option, index) => (fetchedDepartments.includes(option.title) ? index : null))
            .filter(index => index !== null);
          setSelected1(preSelectedIndexes);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermission();
  }, [memId, options1]);

  // Inventory - Transaction (preselect)
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminEdit_inventoryTranscation?memId=${memId}`);
        const fetchedDepartments = response.data.permissions?.map(item => item.fld_department) || [];
        setData(response.data.permissions || []);

        if (options2.length > 0) {
          const preSelectedIndexes = options2
            .map((option, index) => (fetchedDepartments.includes(option.title) ? index : null))
            .filter(index => index !== null);
          setSelected2(preSelectedIndexes);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermission();
  }, [memId, options2]);

  // Inventory - Report (preselect)
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminEdit_inventoryReport?memId=${memId}`);
        const fetchedDepartments = response.data.permissions?.map(item => item.fld_department) || [];
        setData(response.data.permissions || []);

        if (options3.length > 0) {
          const preSelectedIndexes = options3
            .map((option, index) => (fetchedDepartments.includes(option.title) ? index : null))
            .filter(index => index !== null);
          setSelected3(preSelectedIndexes);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermission();
  }, [memId, options3]);

  // Vehicle - Master (preselect)
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminEdit_vehicleMaster?memId=${memId}`);
        const fetchedDepartments = response.data.permissions?.map(item => item.fld_department) || [];
        setData(response.data.permissions || []);

        if (options4.length > 0) {
          const preSelectedIndexes = options4
            .map((option, index) => (fetchedDepartments.includes(option.title) ? index : null))
            .filter(index => index !== null);
          setSelected4(preSelectedIndexes);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermission();
  }, [memId, options4]);

  // Vehicle - Transaction (preselect)
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminEdit_vehicleTranscation?memId=${memId}`);
        const fetchedDepartments = response.data.permissions?.map(item => item.fld_department) || [];
        setData(response.data.permissions || []);

        if (options5.length > 0) {
          const preSelectedIndexes = options5
            .map((option, index) => (fetchedDepartments.includes(option.title) ? index : null))
            .filter(index => index !== null);
          setSelected5(preSelectedIndexes);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermission();
  }, [memId, options5]);

  // Vehicle - Report (preselect)
  useEffect(() => {
    const fetchPermission = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminEdit_vehicleReport?memId=${memId}`);
        const fetchedDepartments = response.data.permissions?.map(item => item.fld_department) || [];
        setData(response.data.permissions || []);

        if (options6.length > 0) {
          const preSelectedIndexes = options6
            .map((option, index) => (fetchedDepartments.includes(option.title) ? index : null))
            .filter(index => index !== null);
          setSelected6(preSelectedIndexes);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermission();
  }, [memId, options6]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/addAdmin_inventory1");
        setOptions1(response.data.addListInventory1 || []); // Inv - Master
        setOptions2(response.data.addListInventory2 || []); // Inv - Trans
        setOptions3(response.data.addListInventory3 || []); // Inv - Report
        setOptions4(response.data.addListInventory5 || []); // Veh - Master
        setOptions5(response.data.addListInventory4 || []); // Veh - Trans
        setOptions6(response.data.addListInventory6 || []); // Veh - Report
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {}, [options1, options2, options3, options4, options5, options6]);

  const handleSelectAll = (options, setSelected, selected) => {
    if (selected.length === options.length) {
      setSelected([]);
    } else {
      setSelected(options.map((_, index) => index));
    }
  };

  const toggleCheckbox = (index, setSelected, selected) => {
    if (selected.includes(index)) {
      setSelected(selected.filter(i => i !== index));
    } else {
      setSelected([...selected, index]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const selectedItems = [
        ...selected1.map(index => options1[index]?.title || ''),
        ...selected2.map(index => options2[index]?.title || ''),
        ...selected3.map(index => options3[index]?.title || ''),
        ...selected4.map(index => options4[index]?.title || ''),
        ...selected5.map(index => options5[index]?.title || ''),
        ...selected6.map(index => options6[index]?.title || '')
      ].filter(item => item.trim() !== "");

      const payload = {
        user: userId,
        memberId: memId,
        userName: formData.userName,
        name: formData.name,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        branch: formData.branch,
        desc: formData.desc,
        cat: formData.cat,
        selectedItems,
        dept: moduleCode
      };

      console.log("Submitting payload:", payload);

      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/admin_edit", payload);

      if (response.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Member Updated successfully!",
        });
        navigate('/admin/admin_members_list');
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Submission failed. Please try again.",
        });
      }

    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Submission failed. Please try again.",
      });
    }
  };

  return (
    <div id="admin-container">
      <SuperAdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Admin Members - Edit</h2>
            <Link to={`/admin/admin_members_list`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>
        <div className="form-container">
          {/* Optional warning if plan has no modules (defensive) */}
          {bothHidden && (
            <div style={{ padding: 12, background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, marginBottom: 16 }}>
              No modules available for your plan. Please contact Nissi Infotech staff.
            </div>
          )}

          <form className="vehicle-form" onSubmit={handleSubmit}>

            <div className="form-row">
              <div className="form-group">
                <label>Member Id :</label>
                <input type="text" name="memberId" value={formData.memberId} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>User Name:</label>
                <input type="text" name="userName" value={formData.userName} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Name :</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Password:</label>
                <input type="text" name="password" value={formData.password} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Designation :</label>
                <input type="text" name="desc" value={formData.desc} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Confirm Password:</label>
                {/* FIX: correct field name/value */}
                <input type="text" name="confirmPassword" value={formData.confirmPassword || ""} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <select name="branch" value={formData.branch} onChange={handleChange}>
                  <option value="">-- Select Branch --</option>
                  {branches.map((item, index) => (
                    <option key={index} value={item.branchMaster_code}>
                      {item.branchMaster_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Select Category :</label>
                <select name="cat" value={formData.cat} onChange={handleChange}>
                  <option value="">-- Select Category --</option>
                  {dept.map((item, index) => (
                    <option key={index} value={item.fld_category}>
                      {item.fld_category}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* ===== MASTER ===== */}
            {!bothHidden && (
              <div
                className="dropdown-container"
                style={gridStyleFor((showInventory ? 1 : 0) + (showVehicle ? 1 : 0))}
              >
                {/* Inventory Master */}
                {showInventory && (
                  <div className="dropdown">
                    <button type="button" onClick={() => setDropdown1Visible(!dropdown1Visible)}>
                      Master Module - Inventory {dropdown1Visible ? "▲" : "▼"}
                    </button>
                    {dropdown1Visible && (
                      <div className="admin-checkbox-container">
                        <label className="admin-checkbox-label">
                          <input
                            type="checkbox"
                            className="admin-checkbox-input"
                            checked={options1.length > 0 && selected1.length === options1.length}
                            onChange={() => handleSelectAll(options1, setSelected1, selected1)}
                          />
                          Select All
                        </label>
                        {options1.map((option, index) => (
                          <label key={index} className="admin-checkbox-label">
                            <input
                              type="checkbox"
                              className="admin-checkbox-input"
                              checked={selected1.includes(index)}
                              onChange={() => toggleCheckbox(index, setSelected1, selected1)}
                            />
                            {option.title || option.name || JSON.stringify(option)}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Vehicle Master */}
                {showVehicle && (
                  <div className="dropdown">
                    <button type="button" onClick={() => setDropdown4Visible(!dropdown4Visible)}>
                      Master Module - Vehicle {dropdown4Visible ? "▲" : "▼"}
                    </button>
                    {dropdown4Visible && (
                      <div className="admin-checkbox-container">
                        <label className="admin-checkbox-label">
                          <input
                            type="checkbox"
                            className="admin-checkbox-input"
                            checked={options4.length > 0 && selected4.length === options4.length}
                            onChange={() => handleSelectAll(options4, setSelected4, selected4)}
                          />
                          Select All
                        </label>
                        {options4.map((option, index) => (
                          <label key={index} className="admin-checkbox-label">
                            <input
                              type="checkbox"
                              className="admin-checkbox-input"
                              checked={selected4.includes(index)}
                              onChange={() => toggleCheckbox(index, setSelected4, selected4)}
                            />
                            {option.title || option.name || JSON.stringify(option)}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* ===== TRANSACTION ===== */}
            {!bothHidden && (
              <div
                className="dropdown-container"
                style={gridStyleFor((showInventory ? 1 : 0) + (showVehicle ? 1 : 0))}
              >
                {/* Inventory Transaction */}
                {showInventory && (
                  <div className="dropdown">
                    <button type="button" onClick={() => setDropdown2Visible(!dropdown2Visible)}>
                      Transcation Module - Inventory {dropdown2Visible ? "▲" : "▼"}
                    </button>
                    {dropdown2Visible && (
                      <div className="admin-checkbox-container">
                        <label className="admin-checkbox-label">
                          <input
                            type="checkbox"
                            className="admin-checkbox-input"
                            checked={options2.length > 0 && selected2.length === options2.length}
                            onChange={() => handleSelectAll(options2, setSelected2, selected2)}
                          />
                          Select All
                        </label>
                        {options2.map((option, index) => (
                          <label key={index} className="admin-checkbox-label">
                            <input
                              type="checkbox"
                              className="admin-checkbox-input"
                              checked={selected2.includes(index)}
                              onChange={() => toggleCheckbox(index, setSelected2, selected2)}
                            />
                            {option.title || option.name || JSON.stringify(option)}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Vehicle Transaction */}
                {showVehicle && (
                  <div className="dropdown">
                    <button type="button" onClick={() => setDropdown5Visible(!dropdown5Visible)}>
                      Transcation Module - Vehicle {dropdown5Visible ? "▲" : "▼"}
                    </button>
                    {dropdown5Visible && (
                      <div className="admin-checkbox-container">
                        <label className="admin-checkbox-label">
                          <input
                            type="checkbox"
                            className="admin-checkbox-input"
                            checked={options5.length > 0 && selected5.length === options5.length}
                            // FIX: correct array for "Select All" was options4 before
                            onChange={() => handleSelectAll(options5, setSelected5, selected5)}
                          />
                          Select All
                        </label>
                        {options5.map((option, index) => (
                          <label key={index} className="admin-checkbox-label">
                            <input
                              type="checkbox"
                              className="admin-checkbox-input"
                              checked={selected5.includes(index)}
                              onChange={() => toggleCheckbox(index, setSelected5, selected5)}
                            />
                            {option.title || option.name || JSON.stringify(option)}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* ===== REPORT ===== */}
            {!bothHidden && (
              <div
                className="dropdown-container"
                style={gridStyleFor((showInventory ? 1 : 0) + (showVehicle ? 1 : 0))}
              >
                {/* Inventory Report */}
                {showInventory && (
                  <div className="dropdown">
                    <button type="button" onClick={() => setDropdown3Visible(!dropdown3Visible)}>
                      Report Module - Inventory {dropdown3Visible ? "▲" : "▼"}
                    </button>
                    {dropdown3Visible && (
                      <div className="admin-checkbox-container">
                        <label className="admin-checkbox-label">
                          <input
                            type="checkbox"
                            className="admin-checkbox-input"
                            checked={options3.length > 0 && selected3.length === options3.length}
                            onChange={() => handleSelectAll(options3, setSelected3, selected3)}
                          />
                          Select All
                        </label>
                        {options3.map((option, index) => (
                          <label key={index} className="admin-checkbox-label">
                            <input
                              type="checkbox"
                              className="admin-checkbox-input"
                              checked={selected3.includes(index)}
                              onChange={() => toggleCheckbox(index, setSelected3, selected3)}
                            />
                            {option.title || option.name || JSON.stringify(option)}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Vehicle Report */}
                {showVehicle && (
                  <div className="dropdown">
                    <button type="button" onClick={() => setDropdown6Visible(!dropdown6Visible)}>
                      Report Module - Vehicle {dropdown6Visible ? "▲" : "▼"}
                    </button>
                    {dropdown6Visible && (
                      <div className="admin-checkbox-container">
                        <label className="admin-checkbox-label">
                          <input
                            type="checkbox"
                            className="admin-checkbox-input"
                            checked={options6.length > 0 && selected6.length === options6.length}
                            onChange={() => handleSelectAll(options6, setSelected6, selected6)}
                          />
                          Select All
                        </label>
                        {options6.map((option, index) => (
                          <label key={index} className="admin-checkbox-label">
                            <input
                              type="checkbox"
                              className="admin-checkbox-input"
                              checked={selected6.includes(index)}
                              onChange={() => toggleCheckbox(index, setSelected6, selected6)}
                            />
                            {option.title || option.name || JSON.stringify(option)}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMember_Admin;
